interface IRoute {
  description: string;
  html: string;
  link: string;
  script: string;
  template: string;
  title: string;
}

class Route implements IRoute {
  constructor(
    template: string,
    title: string,
    description: string,
    link: string,
    script: string
  ) {
    this.description = description;
    this.link = link;
    this.script = script;
    this.template = template;
    this.title = title;
    this.html = "";
  }
  description: string;
  html: string;
  link: string;
  script: string;
  template: string;
  title: string;
}

export { IRoute, Route };
